// extracted by mini-css-extract-plugin
export default {"title2":"COATitle2-module--title2--ba512","white":"COATitle2-module--white--606ec"};